import { motion } from "framer-motion";
import { BrandMark } from "@/components/BrandLogo";

export default function Splash() {
  return (
    <div
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-black diamond-radial"
      data-testid="splash-screen"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        className="flex flex-col items-center"
      >
        <BrandMark variant="icon" size={128} glow />
        <motion.h1
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.8 }}
          className="mt-7 font-heading text-4xl font-bold tracking-tight"
        >
          Diamond<span className="text-gradient-gold"> AI</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.9 }}
          className="mt-3 text-sm uppercase tracking-[0.4em] text-gold/70"
        >
          Think. Create. Build. Execute.
        </motion.p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
        className="absolute bottom-14 h-[2px] w-40 overflow-hidden rounded-full bg-white/5"
      >
        <div
          className="h-full w-1/2 animate-shimmer rounded-full"
          style={{ background: "linear-gradient(90deg, transparent, #D4AF37, transparent)", backgroundSize: "200% 100%" }}
        />
      </motion.div>
    </div>
  );
}
